import React from "react"
import { Link, useLocation } from "react-router-dom";
import { ReactComponent as Person } from "../images/person.svg";
import { ReactComponent as Login } from "../images/login.svg";
// import  { MainData}  from '../data/MainData';
import Logo from './../images/luxinhotel_logo.svg'
import { styled, useTheme } from '@mui/material/styles';
import styl from "styled-components";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
    position: 'relative',
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginRight: 0,
        },
      },
    ],
  }),
);
const Style = styl.div`
    min-height: 10vh;
    width: 100vw;
    z-index: 100;
    display: flex;
    flex-direction: column;
    position: relative;
    background-color:white;// var(--n-grey-01);
    * {
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
            "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
            sans-seri;
    }
    &.persian-font {
        * {
            font-family:iranyekan ;
        }
    }
    .content {
        flex-grow: 1;
        min-height: 100svh;
    }
    .navpad {
        position: relative;
        height: 80px;
        width: 100%;
    }
    .navbar {
        width: calc(100% - calc(var(--universal-pad) * 2));
        z-index: 999;
        box-shadow: 0px 4px 50px -14px #00000028;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        padding: 0 var(--universal-pad);
        height: 60px;
        position: fixed;
        inset: 0 0 auto 0;
        background: black ; //var(--nav-bg);
        backdrop-filter: blur(30px);
        transition: all 0.15s ease-in-out;
        &.big {
            height: 80px;
            .logo {
                padding: 0;
                height: 50px;
            }
            .login {
                .desc-text {
                    font-size: 16px;
                }
            }
        }
        .logo {
            align-self: center;
            height: 40px;
            min-width: 25%;
            padding: 0 0;
            transition: all 0.15s ease-in-out;
            img {
                height: 100%;
            }
        }
        .menu-btn {
            display: none;
        }
        .expand {
            flex-grow: 1;
        }
        .user-container {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color:yellow ;// EDD682 ; //var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            min-width: 150px;
            align-items: flex-end;
            .title {
                width: fit-content;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                font-weight: 700;
                text-decoration: none;
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                box-shadow: 0px 4px 50px -14px #00000028;
                display: none;
                flex-direction: column;
                position: absolute;
                top: calc(100% - 5px);
                left: 0;
                background-color: var(--n-grey-01);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                border-radius: 1rem;
                width: calc(100% + 16px);
                min-width: 150px;
                &.ltr {
                    left: auto;
                    right: 0;
                }
                .login-item {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    text-decoration: none;
                    color: inherit;
                    padding: 4px 0;
                    .icon {
                        img {
                            display: block;
                        }
                    }
                }
            }
            &:hover {
                .items {
                    display: flex;
                }
            }
        }
        .change-lan {
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 0 0;
            text-decoration: none;
            color: var(--fsc-d-1);
            font-size: 14px;
            position: relative;
            .title {
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                padding: 4px 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                background-color: var(--n-grey-1);
                font-weight: 700;
                color:black;// var(--n-grey-2);
                svg {
                    fill: var(--n-grey-2);
                }
            }
            .items {
                position: absolute;
                display: none;
                flex-direction: column;
                top: calc(100% - 10px);
                right: -20px;
                left: -20px;
                background-color: #fff;
                padding: 2px;
                border-radius: 10px;
                box-shadow: 0px 4px 8px -2px #0000005f;
                .item {
                    text-decoration: none;
                    padding: 0.5rem 1rem;
                    text-align: center;
                    border-radius: 8px;
                    color: #000;
                    margin: 0 0;
                    border:1px solid #fff;
                    :first-child {
                        margin: 0 0 0.3rem;
                    }
                    :last-child {
                        margin: 0.3rem 0 0;
                    }
                    &.active {
                        background-color: #eee;
                        border:1px solid #ccc;
                    }
                }
            }
            &:hover {
                .items{
                    display: flex;
                }
            }
        }
        .items {
            display: flex;
            justify-content: center;
            width: 100%;
            margin: auto;
            .navitem {
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0 1rem;
                text-decoration: none;
                color: var(--n-grey-1);
                font-size: 14px;
                position: relative;
                .drop-data {
                    z-index: 5;
                    position: absolute;
                    display: none;
                    flex-direction: column;
                    top: calc(100% + 0px);
                    right: -50px;
                    left: -50px;
                    background-color: #fff;
                    padding: 2px;
                    border-radius: 10px;
                    box-shadow: 0px 4px 8px -2px #0000005f;
                    .navitem {
                        text-decoration: none;
                        padding: 0.5rem 0.5rem;
                        text-align: center;
                        border-radius: 8px;
                        color: #000;
                        margin: 0.3rem 0;
                        border:1px solid #fff;
                        :first-child {
                            margin: 0 0 0.3rem;
                        }
                        :last-child {
                            margin: 0.3rem 0 0;
                        }
                        &.active {
                            background-color: #eee;
                            border:1px solid #ccc;
                        }
                        &&:hover {
                            border:1px solid #ccc;
                        }
                    }

                }
                &:hover {
                    .drop-data {
                        display: flex;
                    }
                }
                &.active {
                    font-weight: 700;
                    color: var(--prime-1);
                }
            }
        }
        .far-side {
            min-width: 25%;
            display: flex;
            gap: 0.5rem;
            flex-direction: row;
            justify-content: flex-end;
        }
    }
    .footer {
        color: var(--fsc-d-1);
        padding: 32px var(--universal-pad);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        box-shadow: 0px -4px 50px -14px #00000028;
        .container-1 {
            width: 25%;
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            .logo {
                img {
                    height: 50px;
                }
            }
            .desc {
                color: var(--n-grey-2);
            }
        }
        .container-2 {
            width: calc(50% - 4rem);
            margin: 0 2rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 1.5rem;
            color: var(--n-grey-2);
            .navitem {
                max-width: calc(100% / 6);
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 0.5rem 0;
                text-decoration: none;
                color: var(--n-grey-2);
                font-size: 14px;
                font-weight: 500;
            }
        }
        .container-3 {
            width: 25%;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .logos {
                width: 100px;
                height: 100px;
                a {
                    border-radius: var(--border-radius-2);
                    display: block;
                    width: 80px;
                    padding: 0.5rem;
                    background-color: var(--n-grey-1);
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
        }
    }
    .down{
        padding: 0.5rem 0;
        text-align: center;

        color: var(--fsc-d-1);
        background: var(--nav-bg);
        backdrop-filter: blur(30px);
        font-size: 0.7rem;
        a {
            color: var(--text-d-1);
            text-decoration: none;
            &:hover {
                color: var(--n-grey-1)
            }
        }
    }
    @media (max-width: 850px){
        .navbar {
            width: calc(100vw - 32px);
            padding: 0 16px 0;
            justify-content: end;
            &.big {
                .logo {
                    padding: 20px 0;
                    height: 40px;
                }
            }
            .expand {
                display: none;
            }
            .logo {
                min-width: 150px;
                padding: 10px 0;
                position: absolute;
                top: 0;
                left: calc(50% - 75px);
                display: flex;
                flex-direction: row;
                justify-content: center;
            }
            .items {
                display: none;
            }
            .change-lan {
                display: none;
            }
            
            .menu-btn {
                z-index: 980;
                overflow: visible;
                cursor: pointer;
                position: fixed;
                top: 10px;
                right: 16px;
                width: 40px;
                height: 40px;
                background-color: #fff;
                display: flex;
                justify-content: center;
                border-radius: 4px;
                transition: all 0.15s ease-in-out;
                border-radius: var(--border-radius-3);
                border: 1px solid var(--n-grey-1);
                background-color: var(--n-grey-01);
                color: var(--n-grey-2);
                &.ltr {
                    right: auto;
                    left: 16px;
                    .menu-container {
                        right: auto;
                        left: -80vw;
                        &.active {
                            left: 0vw;
                        }
                    }
                }
                &.big {
                    top: 20px;
                    width: 40px;
                    height: 40px;
                }
                .menu-btn-img {
                    width: 20px;
                    height: 20px;
                    margin: auto;
                    transition: all 0.3s ease-in-out;
                    &.big {
                        width: 23px;
                        height: 23px;
                    }
                }
                .bg {
                    z-index: 950;
                    position: fixed;
                    inset: 0 0 0 0;
                    width: 100vw;
                    height: 100vh;
                    background-color: #0000005f;
                }
                .menu-container {
                    z-index: 970;
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    background-color: var(--n-grey-01);
                    width: 80vw;
                    height: 100vh;
                    inset: 0 0 0 auto;
                    right: -80vw;
                    transition: all 0.3s ease-in-out;
                    &.active {
                        right: 0vw;
                    }
                    .logo-menu {
                        width: 40%;
                        margin: 70px auto 35px;
                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                    .menu-items {
                        display: flex;
                        flex-direction: column;
                        .navitem {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding: 1rem;
                            text-decoration: none;
                            color: var(--fsc-d-1);
                            font-size: 16px;
                            border-bottom: 1px solid var(--bg-d-3);
                            :last-child{
                                border-bottom: none;
                            }
                            &.active {
                                background-color: #fff;
                                font-weight: 700;
                            }
                        }
                    }
                    .text-s {
                        margin: 1rem auto 0.5rem;
                    }
                    .change-lan {
                        display: flex;
                        flex-direction: column;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        color: var(--fsc-d-1);
                        font-size: 16px;
                        margin: 0 1rem;
                        .title {
                            padding: 1rem;
                        }
                        .items {
                            position: relative;
                            inset: 0;
                            display: flex;
                            flex-direction: column;
                            background-color: #fff;
                            padding: 2px;
                            border-radius: 10px;
                            box-shadow: none;
                        }
                    }
                    .socials {
                        margin: 0.5rem auto 5rem;
                        display: flex;
                        flex-direction: row;
                        .item {
                            margin: 0 0.5rem;
                            :last-child{
                                margin: 0 0.5rem 0 0;
                            }
                            :first-child{
                                margin: 0 0 0 0.5rem;
                            }
                        }
                    }
                }
                
            }
        }
        .footer {
            padding: 32px 16px;
            width: calc(100% - 32px);
            flex-direction: column;
            gap: 2rem;
            .container-1 {
                align-items: center;
                width: 100%;
            }
            .container-2 {
                width: 100%;
                margin: 0;
                .navitem {
                    max-width: calc(100% / 2);
                }
            }
            .container-3 {
                width: 100%;
                justify-content: center;
            }
        }
    }
`;
const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    variants: [
      {
        props: ({ open }) => open,
        style: {
          width: `calc(100% - ${drawerWidth}px)`,
          transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginRight: drawerWidth,
        },
      },
    ],
  }));
  
  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
  }));
  
export default function Header(props) { 
    const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

    let lan='en';  
    let direction='ltr';
return(

  
      <Style className={((direction === "rtl") ? 'persian-font' : '')} style={{direction: direction ,fontFamily: ((direction) ? 'iranyekan' : '')}}>
         <div className={"navbar" +  " big" }>
      <Link to="/" className="logo">
          {/* <img src={Logo} alt="luxinhotel"/> */}
      </Link>
      <div className="items" style={{direction: (lan === 'en' ? 'ltr' :'rtl')}}>
          {/* {makeNavItems()} */}
      </div>
      <div className="expand"></div>
      <div className="far-side">
      <div className="user-container">
           
           <Link to={"/login"} className="title">
               <Person/>
               Login
             
           </Link>
       </div>
          <div className="change-lan">
              <div className="title">
                  <div className="text">sign in</div>
               <Login/>
              </div>
           
          </div>
      </div>
   
  </div>
  <Box sx={{ display: 'flex' }}>
      {/* <CssBaseline /> */}
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }} component="div">
            Persistent drawer
          </Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerOpen}
            sx={[open && { display: 'none' }]}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Main open={open}>
        <DrawerHeader />
        <Typography sx={{ marginBottom: 2 }}>
  
        </Typography>
        <Typography sx={{ marginBottom: 2 }}>
        
        </Typography>
      </Main>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
          },
        }}
        variant="persistent"
        anchor="right"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
            <ListItem key={text} >
              <ListItemButton 
                 >
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem key={text} disablePadding>
              <ListItemButton>
                <ListItemIcon>
                  {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </Box>
  </Style>
)
}









